/* Product Tabs and Gallery JavaScript */

(function() {
  'use strict';

  // Gallery image switching
  window.switchImage = function(thumb, src) {
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    var mainImg = document.getElementById('main-product-image');
    if (mainImg) mainImg.src = src;
  };

  // Tab switching
  function initTabs() {
    const tabButtons = document.querySelectorAll('.product-tabs button');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetTab = this.dataset.tab;

        // Update buttons
        document.querySelectorAll('.product-tabs button').forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        // Update panels
        document.querySelectorAll('.product-tab-body').forEach(panel => {
          panel.hidden = panel.dataset.tab !== targetTab;
        });
      });
    });
  }

  // Qty stepper
  function initQtyStepper() {
    const qtyInput = document.querySelector('#product-form input[name="quantity"]');
    if (qtyInput) {
      const minusBtn = document.querySelector('.js-qty-minus');
      const plusBtn = document.querySelector('.js-qty-plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          if (qtyInput.value > 1) qtyInput.stepDown();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          qtyInput.stepUp();
        });
      }
    }
  }

  // Initialize everything when DOM is ready
  function init() {
    initTabs();
    // initQtyStepper(); – a mennyiségválasztót a theme.js kezeli (dupla léptetés javítása)
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
